import { create } from 'zustand';
import type { SessionUser } from '@agenda-facil/contracts';

interface AuthState {
  accessToken?: string;
  user?: SessionUser;
  hydrated: boolean;
  setSession: (accessToken: string, user: SessionUser) => void;
  clear: () => void;
  setHydrated: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  hydrated: false,
  setSession: (accessToken, user) => set({ accessToken, user, hydrated: true }),
  clear: () => set({ accessToken: undefined, user: undefined, hydrated: true }),
  setHydrated: () => set({ hydrated: true }),
}));
